<template lang="pug">
el-dialog.modal-termo(
  :visible.sync="showModal"
  width="680px"
  :show-close="false"
  :close-on-click-modal="false"
  append-to-body
  custom-class="modal-termo__dialog"
)
  .modal-termo__header
    h2.modal-termo__titulo(
      :class="{ 'modal-termo__titulo--passo-2': passo === 2 }"
    ) {{ tituloAtual }}
    button.modal-termo__fechar(
      type="button"
      aria-label="Fechar"
      @click="fecharModal"
    )
      img(
        src="@/assets/icons/cadastro/x.svg"
        alt=""
      )

  .modal-termo__passos
    .modal-termo__passo(
      :class="{ 'modal-termo__passo--ativo': passo === 1, 'modal-termo__passo--concluido': passo > 1 }"
    )
      span.modal-termo__passo-numero 1
      span.modal-termo__passo-label Termo de compromisso
    .modal-termo__passo-linha
    .modal-termo__passo(
      :class="{ 'modal-termo__passo--ativo': passo === 2 }"
    )
      span.modal-termo__passo-numero 2
      span.modal-termo__passo-label Divulgação de contato

  .modal-termo__conteudo(v-show="passo === 1")
    .modal-termo__scroll
      p.modal-termo__intro {{ introTermo }}

      .modal-termo__accordion
        .modal-termo__accordion-item(
          v-for="(secao, index) in secoesTermo"
          :key="secao.titulo"
        )
          button.modal-termo__accordion-trigger(
            type="button"
            :aria-expanded="secoesAbertas[index]"
            @click="alternarSecao(index)"
          )
            span.modal-termo__accordion-titulo {{ secao.titulo }}
            img.modal-termo__accordion-chevron(
              src="@/assets/icons/cadastro/chevron-down.svg"
              alt=""
              :class="{ 'modal-termo__accordion-chevron--aberto': secoesAbertas[index] }"
            )
          .modal-termo__accordion-painel(v-show="secoesAbertas[index]")
            p.modal-termo__texto(v-if="secao.intro") {{ secao.intro }}
            p.modal-termo__texto(
              v-for="(paragrafo, pIndex) in secao.paragrafos || []"
              :key="`${secao.titulo}-p-${pIndex}`"
            ) {{ paragrafo }}
            ul.modal-termo__lista(v-if="secao.itens && secao.itens.length")
              li.modal-termo__lista-item(
                v-for="(item, iIndex) in secao.itens"
                :key="`${secao.titulo}-i-${iIndex}`"
              ) {{ item }}

    label.modal-termo__checkbox(
      :class="{ 'modal-termo__checkbox--marcado': aceitouTermos }"
    )
      input.modal-termo__checkbox-input(
        type="checkbox"
        v-model="aceitouTermos"
      )
      span.modal-termo__checkbox-box
        img.modal-termo__checkbox-check(
          v-if="aceitouTermos"
          src="@/assets/icons/cadastro/check-white.svg"
          alt=""
        )
      span.modal-termo__checkbox-label
        | Declaro que li e estou de acordo com os termos e cláusulas acima descritos

  .modal-termo__conteudo.modal-termo__conteudo--divulgacao(v-show="passo === 2")
    .modal-termo__scroll.modal-termo__scroll--divulgacao
      .modal-termo__divulgacao-cabecalho
        h3.modal-termo__divulgacao-titulo Autorização para Divulgação de Contatos Profissionais
        p.modal-termo__texto
          | Estou ciente de que o ITERPA mantém uma relação pública de profissionais credenciados, com a finalidade de facilitar o contato entre cidadãos interessados em procedimentos de regularização fundiária e profissionais habilitados para execução de serviços técnicos.

      .modal-termo__opcoes
        label.modal-termo__opcao(
          v-for="opcao in opcoesDivulgacao"
          :key="opcao.valor"
          :class="{ 'modal-termo__opcao--selecionada': preferenciaDivulgacao === opcao.valor }"
        )
          input.modal-termo__opcao-input(
            type="radio"
            name="preferenciaDivulgacao"
            :value="opcao.valor"
            v-model="preferenciaDivulgacao"
          )
          span.modal-termo__opcao-radio
          span.modal-termo__opcao-conteudo
            span.modal-termo__opcao-label {{ opcao.label }}
            span.modal-termo__opcao-descricao(v-if="opcao.descricao") {{ opcao.descricao }}

  .modal-termo__footer
    template(v-if="passo === 1")
      button.modal-termo__btn.modal-termo__btn--outline(
        type="button"
        @click="fecharModal"
      ) Voltar ao cadastro
      button.modal-termo__btn.modal-termo__btn--primary(
        type="button"
        :disabled="!aceitouTermos"
        @click="avancarParaDivulgacao"
      )
        | Continuar
        img.modal-termo__btn-icone(
          src="@/assets/icons/cadastro/arrow-right.svg"
          alt=""
        )

    template(v-else)
      button.modal-termo__btn.modal-termo__btn--outline(
        type="button"
        @click="voltarAoTermo"
      )
        img.modal-termo__btn-icone(
          src="@/assets/icons/cadastro/arrow-left.svg"
          alt=""
        )
        | Voltar ao termo
      button.modal-termo__btn.modal-termo__btn--primary(
        type="button"
        :disabled="!preferenciaDivulgacao"
        @click="confirmar"
      )
        img.modal-termo__btn-icone(
          src="@/assets/icons/cadastro/check-white.svg"
          alt=""
        )
        | Finalizar
</template>

<script>
import {
  DIVULGACAO_CONTATO_OPCOES,
  TERMO_COMPROMISSO_INTRO,
  getSecoesTermoCompromisso
} from '@/constants/cadastroPublico'

export default {
  name: 'ModalTermoCompromisso',
  props: {
    modalOpen: {
      type: Boolean,
      default: false
    },
    tipoCadastro: {
      type: String,
      default: 'GEOMENSOR'
    }
  },
  data () {
    return {
      passo: 1,
      aceitouTermos: false,
      preferenciaDivulgacao: '',
      secoesAbertas: [true, false, false, false, false],
      introTermo: TERMO_COMPROMISSO_INTRO,
      opcoesDivulgacao: DIVULGACAO_CONTATO_OPCOES
    }
  },
  computed: {
    showModal: {
      get () {
        return this.modalOpen
      },
      set () {
        this.$emit('close-modal')
      }
    },
    tituloAtual () {
      return this.passo === 1
        ? 'Termo de Compromisso e Responsabilidade'
        : 'Autorização de Divulgação de Contato'
    },
    secoesTermo () {
      return getSecoesTermoCompromisso(this.tipoCadastro)
    }
  },
  watch: {
    modalOpen (aberto) {
      if (aberto) {
        this.resetarEstado()
      }
    }
  },
  methods: {
    resetarEstado () {
      this.passo = 1
      this.aceitouTermos = false
      this.preferenciaDivulgacao = ''
      this.secoesAbertas = [true, false, false, false, false]
    },
    alternarSecao (index) {
      this.$set(this.secoesAbertas, index, !this.secoesAbertas[index])
    },
    avancarParaDivulgacao () {
      if (!this.aceitouTermos) {
        return
      }
      this.passo = 2
    },
    voltarAoTermo () {
      this.passo = 1
    },
    fecharModal () {
      this.$emit('close-modal')
    },
    confirmar () {
      if (!this.preferenciaDivulgacao) {
        return
      }
      this.$emit('confirmar', this.preferenciaDivulgacao)
    }
  }
}
</script>

<style lang="scss">
.modal-termo__dialog {
  border-radius: 8px;
  margin-top: 8vh !important;
  max-width: calc(100vw - 32px);

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    color: #141414;
    padding: 20px;
  }
}
</style>

<style lang="scss" scoped>
.modal-termo__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  position: relative;
}

.modal-termo__titulo {
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
  padding-right: 48px;

  &--passo-2 {
    font-size: 18px;
    line-height: 1.375;
  }
}

.modal-termo__fechar {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  position: absolute;
  right: 0;
  top: -1px;
  width: 40px;

  img {
    display: block;
    height: 16px;
    width: 16px;
  }
}

.modal-termo__passos {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-bottom: 16px;
  width: 100%;
}

.modal-termo__passo {
  align-items: center;
  display: flex;
  gap: 8px;
}

.modal-termo__passo-numero {
  align-items: center;
  background: #f5f5f5;
  border-radius: 999px;
  color: #8a8a8a;
  display: inline-flex;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 12px;
  font-weight: 600;
  height: 24px;
  justify-content: center;
  line-height: 16px;
  width: 24px;
}

.modal-termo__passo-label {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
}

.modal-termo__passo--ativo {
  .modal-termo__passo-numero {
    background: #18c5c2;
    color: #ffffff;
  }

  .modal-termo__passo-label {
    color: #141414;
  }
}

.modal-termo__passo--concluido {
  .modal-termo__passo-numero {
    background: rgba(24, 197, 194, 0.2);
    color: #18c5c2;
  }

  .modal-termo__passo-label {
    color: #8a8a8a;
  }
}

.modal-termo__passo-linha {
  background: #eaeaea;
  flex: 1;
  height: 1px;
  min-width: 24px;
}

.modal-termo__conteudo {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-termo__scroll {
  border: 1px solid #eaeaea;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 380px;
  overflow-y: auto;
  padding: 16px;

  &--divulgacao {
    height: auto;
    min-height: 0;
    overflow: visible;
  }
}

.modal-termo__intro,
.modal-termo__texto,
.modal-termo__lista-item {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  line-height: 1.625;
  margin: 0;
}

.modal-termo__accordion {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.modal-termo__accordion-item {
  border-bottom: 1px solid #eaeaea;
}

.modal-termo__accordion-trigger {
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  padding: 8px 12px;
  text-align: left;
  width: 100%;
}

.modal-termo__accordion-titulo {
  color: #1f1f1f;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.modal-termo__accordion-chevron {
  display: block;
  flex-shrink: 0;
  height: 16px;
  transition: transform 0.2s ease;
  width: 16px;

  &--aberto {
    transform: rotate(180deg);
  }
}

.modal-termo__accordion-painel {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 12px 12px;
}

.modal-termo__lista {
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.modal-termo__lista-item {
  line-height: 1.5;
  padding-left: 12px;
  position: relative;

  &::before {
    content: '•';
    left: 0;
    position: absolute;
  }
}

.modal-termo__checkbox {
  align-items: flex-start;
  cursor: pointer;
  display: flex;
  gap: 8px;
}

.modal-termo__checkbox-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.modal-termo__checkbox-box {
  align-items: center;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  display: inline-flex;
  flex-shrink: 0;
  height: 16px;
  justify-content: center;
  margin-top: 1px;
  width: 16px;
}

.modal-termo__checkbox--marcado .modal-termo__checkbox-box {
  background: #1e174e;
  border-color: #1e174e;
}

.modal-termo__checkbox-check {
  display: block;
  height: 12px;
  width: 12px;
}

.modal-termo__checkbox-label {
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}

.modal-termo__divulgacao-cabecalho {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.modal-termo__divulgacao-titulo {
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
}

.modal-termo__opcoes {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.modal-termo__opcao {
  align-items: flex-start;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: 12px;
  padding: 16px;
}

.modal-termo__opcao--selecionada {
  border-color: #1e174e;
}

.modal-termo__opcao-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.modal-termo__opcao-radio {
  border: 1px solid #eaeaea;
  border-radius: 999px;
  flex-shrink: 0;
  height: 16px;
  margin-top: 2px;
  width: 16px;
}

.modal-termo__opcao--selecionada .modal-termo__opcao-radio {
  background: #1e174e;
  border-color: #1e174e;
  box-shadow: inset 0 0 0 3px #ffffff;
}

.modal-termo__opcao-conteudo {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.modal-termo__opcao-label {
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.modal-termo__opcao-descricao {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  line-height: 1.625;
}

.modal-termo__footer {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  margin-top: 24px;
}

.modal-termo__btn {
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  gap: 6px;
  height: 40px;
  justify-content: center;
  line-height: 20px;
  padding: 0 10px;
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &--outline {
    background: #ffffff;
    border: 1px solid #eaeaea;
    color: #141414;
  }

  &--primary {
    background: #1e174e;
    border: 1px solid transparent;
    color: #ffffff;
  }
}

.modal-termo__btn-icone {
  display: block;
  height: 16px;
  width: 16px;
}

@media (max-width: 720px) {
  .modal-termo__titulo {
    font-size: 18px;
    line-height: 1.375;
  }

  .modal-termo__passos {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .modal-termo__passo-linha {
    display: none;
  }

  .modal-termo__scroll {
    height: min(380px, 50vh);

    &--divulgacao {
      height: auto;
    }
  }

  .modal-termo__footer {
    flex-direction: column-reverse;
  }

  .modal-termo__btn {
    width: 100%;
  }
}
</style>
